import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import {
    IContract,
    ITransport,
    IVehicleElement,
} from "dataModels/contract";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    requestPending,
    requestPristine,
    requestSuccess,
} from "state/reducer/requestStatusSlice";
import { getContract, getTransport } from "net/contracts";
import {  Table, Textlink } from "@ds/ds-snam/react";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { getReservations } from "net/b2b";
import {
    AppUserGrant,
    BadgeStatus,
    CalendarSlotStatus,
    DATE_FORMAT,
    DsLayout,
    EntityType,
    IAppUserProfile,
    RoutePath,
} from "shared/constants";
import moment from "moment";
import { useNavigate } from "react-router";
import NoDataFound from "components/NoDataFound";
import useRequestStatus from "hooks/useRequestStatus";
import { getBadgeStatus } from "views/contractView/shared/driverVehicleBadgeStatus";
import { getVehicles } from "net/contracts";
import axios from "axios";
import { IBookingElement } from "views/b2bView/bookingList";
import { getBookingBadgeStatus } from "views/b2bView/shared/bookingBadgeStatus";
import CalendarView from "views/b2bView/components/calendarView";
import ContractSlotChart from "views/contractView/components/contractSlotChart";
import DriverVehicleListTableLegend from "views/contractView/components/driverVehicleListTableLegend";
import "views/dashboardView/styles/dashboardViewStyles.css";
import {
    getBookingLegend,
    getDelegationLegend,
    parseService,
} from "views/contractView/shared/listUtils";
import useAppUser from "hooks/useAppUser";
import { AppUserRole } from "shared/constants";
import { AppUser } from "ooAuth2/appUser";
import ClientContractFilter from "./components/clientContractFilter";
import {  RootState } from "state/appStore";
import { ITableCell, ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";
const DashboardView: React.FC<{}> = (): JSX.Element => {
    const { t, i18n } = useTranslation([
        "contract",
        "preBilling",
        "app",
        "dashboard",
    ]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const appUserProfile: IAppUserProfile | undefined =
        useAppUser()?.userProfile;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });

    /** DELEGHE */
    const [transportData, setTransportData] = useState<ITransport>();
    const [transportDataFiltered, setTransportDataFiltered] = useState<ITransport>();
    const loadTransportData = useCallback(() => {
        if (appUserProfile) {
            dispatch(requestPending());
            getTransport(appUser!.getCarriers()![0].toString())
                .then((response) => {
                    const transportResponse = response.data;
                    setTransportData(transportResponse);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
        }
    }, [dispatch]);

    const tableColsDelegations = (() => {
        return [
            t("dashboard.tableColsDelegations.0", { ns: "dashboard" }),
            t("dashboard.tableColsDelegations.1", { ns: "dashboard" }),
        ];
        //return t("transporter.transportData.tableColumnsDelegations", { ns: 'contract', returnObjects: true }) as string[];
    })();

    /** VEHICLES (componenti) */
    const requestStatusVehicle = useRequestStatus();
    const [vehicleList, setVehicleList] = useState<{
        [BadgeStatus.TO_CREDIT]: IVehicleElement[];
        [BadgeStatus.CREDITED]: IVehicleElement[];
    }>();
    const [vehicleListFiltered, setVehicleListFiltered] = useState<{
        [BadgeStatus.TO_CREDIT]: IVehicleElement[];
        [BadgeStatus.CREDITED]: IVehicleElement[];
    }>();
    const [filtersAwaiting, setFiltersAwaiting] = useState<{
        [key: string]: string;
    }>({
        col1: "",
        col2: "",
    });
    const [filtersCredited, setFiltersCredited] = useState<{
        [key: string]: string;
    }>({
        col1: "",
        col2: "",
    });



    const getVehicleColumns = (status: BadgeStatus) => {
        return [
            t("dashboard.vehicleColumns.0", { ns: "dashboard" }),
            t("dashboard.vehicleColumns.1", { ns: "dashboard" }),
            t("dashboard.vehicleColumns.2", { ns: "dashboard" }),
        ];
    };
    const loadVehiclesList = useCallback(() => {
        dispatch(requestPending());
        const creditedRequest = getVehicles(BadgeStatus.CREDITED);
        const toCreditRequest = getVehicles(BadgeStatus.TO_CREDIT);
        axios
            .all([toCreditRequest, creditedRequest])
            .then(
                axios.spread((...responses) => {
                    setVehicleList({
                        [BadgeStatus.TO_CREDIT]: responses[0],
                        [BadgeStatus.CREDITED]: responses[1],
                    });
                    setVehicleListFiltered({
                        [BadgeStatus.TO_CREDIT]: responses[0],
                        [BadgeStatus.CREDITED]: responses[1],
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }, [dispatch]);
    const getVehicleListSearchColumnsAwaiting = (index: number) => {
        return index === 0 || index === 1;
    };

    // Gestione dei cambiamenti dei filtri
    const handleFilterChangeAwaiting = (columnKey: string, value: string) => {
        setFiltersAwaiting((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };
    const handleFilterChangeCredited = (columnKey: string, value: string) => {
        setFiltersCredited((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };


    useEffect(() => {
        if (vehicleList) {
            setVehicleListFiltered({
                [BadgeStatus.TO_CREDIT]: vehicleList[
                    BadgeStatus.TO_CREDIT
                ].filter(
                    (vehicle) =>
                        //vehicle.type.toLowerCase().includes(filterColumn0Awaiting.toLowerCase()) &&
                        vehicle.licencePlate
                            .toLowerCase()
                            .includes(filtersAwaiting.col2.toLowerCase()) &&
                        t(`vehicle.vehicleList.vehicleType.${vehicle.type}`, {
                            ns: ["contract"],
                        })
                            .toLowerCase()
                            .includes(filtersAwaiting.col1.toLowerCase())
                ),
                [BadgeStatus.CREDITED]: vehicleList[
                    BadgeStatus.CREDITED
                ].filter(
                    (vehicle) =>
                        //vehicle.firstName.toLowerCase().includes(filterColumn0Credited.toLowerCase()) &&
                        vehicle.licencePlate
                            .toLowerCase()
                            .includes(filtersCredited.col2.toLowerCase()) &&
                        t(`vehicle.vehicleList.vehicleType.${vehicle.type}`, {
                            ns: ["contract"],
                        })
                            .toLowerCase()
                            .includes(filtersCredited.col1.toLowerCase())
                ),
            });
        }
    }, [filtersAwaiting, filtersCredited]);

    /** BOOKINGS */
    const [bookings, setBookings] = useState<IBookingElement[]>([]);
    const [bookingsFiltered, setBookingsFiltered] = useState<IBookingElement[]>(
        []
    );
    const [filtersBookings, setFiltersBookings] = useState<{
        [key: string]: string;
    }>({
        col1: "",
        col4: "",
        col5: "",
        col6: "",
    });
    const [isAscending, setIsAscending] = useState<boolean | null>(null); // Stato per tracciare l'ordine

    const loadBookingsList = useCallback(() => {
        dispatch(requestPending());
        getReservations()
            .then((response) => {
                dispatch(requestSuccess());
                setBookings(response.data as IBookingElement[]);
                setBookingsFiltered(response.data as IBookingElement[]);
            })
            .catch((error) => {
                dispatch(requestPristine());
                console.log(error);
            });
    }, [dispatch]);

    const tableBookingsCols = (() => {
        return [
            t("booking.bookingList.tableColumns.0", { ns: "b2b" }) as string,
            t("booking.bookingList.tableColumns.1", { ns: "b2b" }) as string,
            t("booking.bookingList.tableColumns.2", { ns: "b2b" }) as string,
            t("booking.bookingList.tableColumns.3", { ns: "b2b" }) as string,
            t("booking.bookingList.tableColumns.4", { ns: "b2b" }) as string,
            t("booking.bookingList.tableColumns.5", { ns: "b2b" }) as string,
            //t("booking.bookingList.tableColumns.6",{ns:'b2b'}) as string,
        ];
    })();

    //FILTER
    const [contractId, setContractId] = useState<string | undefined>();
    const [businessId, setBusinessId] = useState<string | undefined>();
    const [selectedBusiness, setSelectedBusiness] = useState<
        ISelectLabel | undefined
    >(); //Need this because /contract-list response json has only businessName and not businessId,, otherwhise I could use businessId

    const [contractData, setContractData] = useState<IContract|undefined>();
    const selectContractId = (_contractId: string | undefined) => {
        setContractId(_contractId);
    };
    const selectBusinessId = (_businessId: string | undefined) => {
        setBusinessId(_businessId);
    };
    const selectSelectedBusiness = (
        _selectedBusiness: ISelectLabel | undefined
    ) => {
        setSelectedBusiness(_selectedBusiness);
    };
    //Load data for chart
    const loadContractData = useCallback(() => {
        if (contractId && contractId !== "-1") {
            dispatch(requestPending());
            getContract(contractId)
                .then((response) => {
                    const contractResponse = response.data;
                    setContractData(contractResponse);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
        }else{
            setContractData(undefined);
        }
    }, [dispatch, contractId]);
    useEffect(() => {
        loadBookingsList();
        loadVehiclesList();
        if (appUserRole === AppUserRole.CARRIER) {
            loadTransportData();
        }
        if(appUserRole === AppUserRole.PROPERTY_AND_CASUALTY){
            navigate(
                RoutePath.PRE_BILLING_INFO
            );
        }
        if(appUserRole === AppUserRole.ACCESS_STAFF){
            navigate(
                RoutePath.B2B_BOOKINGS_INFO
            );
        }
    }, []);
    
    
    useEffect(() => {
        loadContractData();
    }, [contractId]);

    const getComponentAndBookingsTable = (type: string) => {
        return (
            <>
                <div style={{ marginTop: "20px", height: "10%" }}>
                    <div
                        style={{
                            float: "left",
                            width: "fit-content",
                            fontWeight: "bold",
                            fontFamily: "Lato, Lato-local, sans-serif",
                            fontSize: "120%",
                            color:
                                layoutMode === DsLayout.DARK_MODE
                                    ? "white"
                                    : "black",
                        }}
                    >
                        {type === "bookings"
                            ? t("dashboard.titles.2", { ns: "dashboard" })
                            : (
                                type==="components_to_credit"?
                                    t("dashboard.titles.13", { ns: "dashboard" })
                                :
                                    t("dashboard.titles.4", { ns: "dashboard" })
                            )
                        
                        }
                    </div>
                    <div style={{ float: "right", width: "fit-content" }}>
                        <Textlink
                            textlinkSelected={false}
                            isTopBarVariant={true}
                            textlinkUrl="javascript:void(0)"
                            textlinkText={
                                type === "bookings"
                                    ? t("dashboard.titles.3", {
                                          ns: "dashboard",
                                      })
                                    : (
                                       type==="components_to_credit"?
                                        t("dashboard.titles.12", {
                                                ns: "dashboard",
                                            })
                                       :
                                      t("dashboard.titles.5", {
                                          ns: "dashboard",
                                      })

                                    )
                            }
                            textlinkTextSize="SMALL"
                            isRouterLink={true}
                            textlinkAriaLabel="aria-Textlink"
                            onClickLink={() => {
                                if (type === "bookings") {
                                    navigate(RoutePath.B2B_BOOKINGS_INFO);
                                } else {
                                    navigate(RoutePath.CONTRACTS_VEHICLE_INFO);
                                }
                            }}
                        />
                    </div>
                </div>
                <div style={{ height: "70%"/*, overflowY: "hidden"*/ }}>
                    {type === "bookings" ? (
                        <>
                            {bookings /*&& bookings.length*/ ? (
                                <>
                                {<Table 
                                        tableConfig={myTableConfigBookings} 
                                        style={{}}
                                        onInputSearchBarChange={(event:Event)=>{
                                            //console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                            /*switch((event as CustomEvent).detail.cells){
                                                case 0:
                                                    handleFilterChangeBookings("col1",(event as CustomEvent).detail.searchedText)
                                                break;
                                                case 4:
                                                    handleFilterChangeBookings("col5",(event as CustomEvent).detail.searchedText)
                                                break;
                                                case 5:
                                                    handleFilterChangeBookings("col6",(event as CustomEvent).detail.searchedText)
                                                break;
                                            }*/
                                        }}
                                        onSubmitSearchedText={(event:Event)=>{
                                            const focusColtemp = (event as CustomEvent).detail.cells;
                                            let focusCol = '';
                                            switch (focusColtemp) {
                                                case 0:
                                                    focusCol = "col1";
                                                    break;
                                                case 4:
                                                    focusCol = "col5";
                                                    break;
                                                case 5:
                                                    focusCol = "col6";
                                                    break;
                                                default:
                                                    break;
                                            }
                                            const focusValue = (event as CustomEvent).detail.searchedText;
                                            handleFilterChangeBookings(focusCol, focusValue)
                                        }}
                                        onResetSearch={(event:Event)=>{
                                            //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                                            switch ((event as CustomEvent).detail.cells) {
                                                case 0:
                                                    handleFilterChangeBookings("col1", "");
                                                    break;
                                                case 4:
                                                    handleFilterChangeBookings("col5", "");
                                                    break;
                                                case 5:
                                                    handleFilterChangeBookings("col6", "");
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }}
                                        //FILTERS
                                        onClickRightAction={(event:Event)=>{
                                            //console.log(event)
                                            //navigate(contractListFiltered[(event as CustomEvent).detail.row].contractId);
                                        }}
                                        onTableInputChange={(event:Event)=>{
                                            //console.log(event)
                                            const focusCol = (event as CustomEvent).detail.col;
                                            const focusValue = (event as CustomEvent).detail.value;
                                            //console.log(focusCol + " - " + focusValue)
                                            //handleFilterChangeBookings(focusCol, focusValue)
                                        }}
                                        onColumnSorting={(event:Event)=>{
                                            //console.log((event as CustomEvent).detail.columnID) 
                                            switch((event as CustomEvent).detail.columnID){
                                              case "col2":
                                                handleSortColumn1()
                                                break;
                                              default:  
                                                break;
                                            }
                                        }}
                                    />}
                            </>
                            ) : (
                                <NoDataFound
                                    title={t(
                                        "booking.bookingList.noData.title"
                                    )} //"Non sono presenti prenotazioni"
                                    subTitle={t(
                                        "booking.bookingList.noData.subTitle"
                                    )}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {vehicleList /*&& vehicleListFiltered[BadgeStatus.TO_CREDIT].length && requestStatusVehicle === RequestStatus.PRISTINE*/ ? (
                                <>
                                    {type === "components_to_credit" ?
                                        <Table 
                                            tableConfig={myTableConfigVehicles_toCredit} 
                                            style={{}}
                                            onInputSearchBarChange={(event:Event)=>{
                                                console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                            }}
                                            onSubmitSearchedText={(event:Event)=>{
                                                const focusColtemp = (event as CustomEvent).detail.cells;
                                                let focusCol = '';
                                                switch (focusColtemp) {
                                                    case 0:
                                                        focusCol = "col1";
                                                        break;
                                                    case 1:
                                                        focusCol = "col2";
                                                        break;
                                                    case 2:
                                                        focusCol = "col3";
                                                        break;
                                                    case 3:
                                                        focusCol = "col4";
                                                        break;
                                                    case 4:
                                                        focusCol = "col5";
                                                        break;
                                                    case 5:
                                                        focusCol = "col6";
                                                        break;
                                                    default:
                                                        break;
                                                }
                                                const focusValue = (event as CustomEvent).detail.searchedText;
                                                handleFilterChangeAwaiting(focusCol, focusValue)
                                            }}
                                            onResetSearch={(event:Event)=>{
                                                //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                                                switch ((event as CustomEvent).detail.cells) {
                                                    case 0:
                                                        handleFilterChangeAwaiting("col1", "");
                                                        break;
                                                    case 1:
                                                        handleFilterChangeAwaiting("col2", "");
                                                        break;
                                                    case 2:
                                                        handleFilterChangeAwaiting("col3", "");
                                                        break;
                                                    case 3:
                                                        handleFilterChangeAwaiting("col4", "");
                                                        break;
                                                    case 4:
                                                        handleFilterChangeAwaiting("col5", "");
                                                        break;
                                                    case 5:
                                                        handleFilterChangeAwaiting("col6", "");
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }}
                                            //FILTERS
                                            onClickRightAction={(event:Event)=>{
                                                //console.log(event)
                                                //navigate(contractListFiltered[(event as CustomEvent).detail.row].contractId);
                                            }}
                                            onTableInputChange={(event:Event)=>{
                                                //console.log(event)
                                                const focusCol = (event as CustomEvent).detail.col;
                                                const focusValue = (event as CustomEvent).detail.value;
                                                //console.log(focusCol + " - " + focusValue)
                                                //handleFilterChangeAwaiting(focusCol, focusValue)
                                            }}
                                            onColumnSorting={(event:Event)=>{
                                                //console.log((event as CustomEvent).detail.columnID) 
                                                /*switch((event as CustomEvent).detail.columnID){
                                                case "col2":
                                                    handleSortColumn1()
                                                    break;
                                                default:  
                                                    break;
                                                }*/
                                            }}
                                        />
                                    :
                                        <Table 
                                            tableConfig={myTableConfigVehicles_toApprove} 
                                            style={{}}
                                            onInputSearchBarChange={(event:Event)=>{
                                                console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                            }}
                                            //FILTERS
                                            onClickRightAction={(event:Event)=>{
                                                //console.log(event)
                                                //navigate(contractListFiltered[(event as CustomEvent).detail.row].contractId);
                                            }}
                                            onSubmitSearchedText={(event:Event)=>{
                                                const focusColtemp = (event as CustomEvent).detail.cells;
                                                let focusCol = '';
                                                switch (focusColtemp) {
                                                    case 0:
                                                        focusCol = "col1";
                                                        break;
                                                    case 1:
                                                        focusCol = "col2";
                                                        break;
                                                    case 2:
                                                        focusCol = "col3";
                                                        break;
                                                    case 3:
                                                        focusCol = "col4";
                                                        break;
                                                    case 4:
                                                        focusCol = "col5";
                                                        break;
                                                    case 5:
                                                        focusCol = "col6";
                                                        break;
                                                    default:
                                                        break;
                                                }
                                                const focusValue = (event as CustomEvent).detail.searchedText;
                                                handleFilterChangeCredited(focusCol, focusValue)
                                            }}
                                            onResetSearch={(event:Event)=>{
                                                //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                                                switch ((event as CustomEvent).detail.cells) {
                                                    case 0:
                                                        handleFilterChangeCredited("col1", "");
                                                        break;
                                                    case 1:
                                                        handleFilterChangeCredited("col2", "");
                                                        break;
                                                    case 2:
                                                        handleFilterChangeCredited("col3", "");
                                                        break;
                                                    case 3:
                                                        handleFilterChangeCredited("col4", "");
                                                        break;
                                                    case 4:
                                                        handleFilterChangeCredited("col5", "");
                                                        break;
                                                    case 5:
                                                        handleFilterChangeCredited("col6", "");
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }}
                                            onTableInputChange={(event:Event)=>{
                                                //console.log(event)
                                                const focusCol = (event as CustomEvent).detail.col;
                                                const focusValue = (event as CustomEvent).detail.value;
                                                //console.log(focusCol + " - " + focusValue)
                                                //handleFilterChangeCredited(focusCol, focusValue)
                                            }}
                                            onColumnSorting={(event:Event)=>{
                                                //console.log((event as CustomEvent).detail.columnID) 
                                                /*switch((event as CustomEvent).detail.columnID){
                                                case "col2":
                                                    handleSortColumn1()
                                                    break;
                                                default:  
                                                    break;
                                                }*/
                                            }}
                                        />
                                    }
                                </>
                            ) : (
                                <></>
                            )}
                        </>
                    )}
                </div>
                <div style={{ marginTop: "20px", height: "5%" }}>
                    {type === "bookings" ? (
                        <>{getBookingLegend(t,[CalendarSlotStatus.CONFIRMED,CalendarSlotStatus.PENDING, CalendarSlotStatus.REJECTED, CalendarSlotStatus.CLOSED, CalendarSlotStatus.CANCELLED, CalendarSlotStatus.SLOT_DELETED])}</>
                    ) : (
                        type==="components_to_credit"?
                            <DriverVehicleListTableLegend
                                entityType={EntityType.VEHICLE}
                                tableType={BadgeStatus.NOT_CREDITED}
                            />
                        :
                            <DriverVehicleListTableLegend
                                entityType={EntityType.VEHICLE}
                                tableType={BadgeStatus.TOAPPROVE}
                            />
                    )}
                </div>
            </>
        );
    };

    const getTableRowsBookings = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        let test : ITableCell
        for (let i in bookingsFiltered) {
            let tempObj: ITableRow = {
                tableCells: [
                    { 
                        type: "text-badge", 
                        text: bookingsFiltered[i].reservationCode,
                        badgeStatus: getBookingBadgeStatus(bookingsFiltered[i].status) as ITableCell['badgeStatus'], //"confirm"
                        badgeCustomColor: bookingsFiltered[i].status===CalendarSlotStatus.CLOSED?"#320216":(bookingsFiltered[i].status===CalendarSlotStatus.CANCELLED?"#9A0557":"#4956B0")
                    },
                    {
                        type: "text",
                        text: parseDateForDS(
                            moment.unix(bookingsFiltered[i].date).format(DATE_FORMAT),
                            IParseDateFormatType.DATE_FORMAT1
                        ),
                    },
                    { type: "text", text: bookingsFiltered[i].time },
                    { type: "text", text: bookingsFiltered[i].businessName },
                    {
                        type: "text",
                        text: bookingsFiltered[i].shipperName
                            ? bookingsFiltered[i].shipperName
                            : "",
                    },
                    {
                        type: "text",
                        text: bookingsFiltered[i].service?.toString()
                            ? parseService(bookingsFiltered[i].service)
                            : "",
                    },
                ],
                //rightIcon: "icon-chevron-right",
            };
            myRetArr.push(tempObj);
        }
        return myRetArr;
    };

    const getTableRowsVehicles = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        if(vehicleListFiltered!==undefined){
            for (let i in vehicleListFiltered[BadgeStatus.CREDITED]) {
                let tempObj: ITableRow = {
                    tableCells: [
                        { 
                            type: "text-badge", 
                            text: t(`vehicle.vehicleList.vehicleType.${vehicleListFiltered[BadgeStatus.CREDITED][i].type}`),
                            badgeStatus: getBadgeStatus(vehicleListFiltered[BadgeStatus.CREDITED][i].status, BadgeStatus.CREDITED) as "error" | "confirm" | "warning" | "info" | "neutral" | "disabled" | "custom" | undefined,
                        },
                        {
                            type: "text",
                            text: vehicleListFiltered[BadgeStatus.CREDITED][i].licencePlate,
                        },
                        {   type: "text", 
                            text: parseDateForDS(
                                moment.unix(vehicleListFiltered[BadgeStatus.CREDITED][i].date).format(DATE_FORMAT),
                                IParseDateFormatType.DATE_FORMAT1
                            )
                        }
                    ],
                    //rightIcon: "icon-chevron-right",
                };
                myRetArr.push(tempObj);
            }
        }
        return myRetArr;
    };

    const getTableRowsVehiclesToCredit = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        if(vehicleListFiltered!==undefined){
            for (let i in vehicleListFiltered[BadgeStatus.TO_CREDIT]) {
                let tempObj: ITableRow = {
                    tableCells: [
                        { 
                            type: "text-badge", 
                            text: t(`vehicle.vehicleList.vehicleType.${vehicleListFiltered[BadgeStatus.TO_CREDIT][i].type}`),
                            badgeStatus: getBadgeStatus(vehicleListFiltered[BadgeStatus.TO_CREDIT][i].status, BadgeStatus.TO_CREDIT) as "error" | "confirm" | "warning" | "info" | "neutral" | "disabled" | "custom" | undefined,
                        },
                        {
                            type: "text",
                            text: vehicleListFiltered[BadgeStatus.TO_CREDIT][i].licencePlate,
                        },
                        {   type: "text", 
                            text: parseDateForDS(
                                moment.unix(vehicleListFiltered[BadgeStatus.TO_CREDIT][i].date).format(DATE_FORMAT),
                                IParseDateFormatType.DATE_FORMAT1
                            )
                        }
                    ],
                    //rightIcon: "icon-chevron-right",
                };
                myRetArr.push(tempObj);
            }
        }
        return myRetArr;
    };

    const getTableDelegations = (): ITableRow[] => {
        let myRetArr: ITableRow[] = [];
        if(transportDataFiltered!==undefined){
            for (let i in transportDataFiltered.delegations) {
                let tempObj: ITableRow = {
                    tableCells: [
                        { 
                            type: "text-badge", 
                            text: transportDataFiltered.delegations[i].businessName,
                            badgeStatus: transportDataFiltered.delegations[i].document.status === BadgeStatus.EXPIRED ? 
                                "error"
                            : (transportDataFiltered.delegations[i].document.status === BadgeStatus.TOAPPROVE ? 
                                "warning"
                              : (transportDataFiltered.delegations[i].document.status === BadgeStatus.APPROVED ? 
                                  "confirm"
                                : 
                                  "error"))
                        },
                        {   type: "text", 
                            text: (transportDataFiltered.delegations[i].document.expire !== null) ?
                                parseDateForDS(moment.unix(transportDataFiltered.delegations[i].document.expire as number).format(DATE_FORMAT), IParseDateFormatType.DATE_FORMAT1)
                                :
                                ""
                        }
                    ],
                    //rightIcon: "icon-chevron-right",
                };
                myRetArr.push(tempObj);
            }
        }
        return myRetArr;
    };

    const myTableConfigBookings: ITableConfig = {
        ...getDSTableSharedElements(280),
        tableHeader: {
            tableCellsHeader: [
                {
                    ...getDSTableShaderElementsForFilterColumn(t("booking.bookingList.tableColumns.0", {
                        ns: "b2b",
                    }) as string,"col1","20%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersBookings["col1"], //<---
                    
                },
                getTableCellsHeaderSimple(t("booking.bookingList.tableColumns.1", {
                    ns: "b2b",
                }) as string,"col2","16%","left",true),
                getTableCellsHeaderSimple(t("booking.bookingList.tableColumns.2", {
                    ns: "b2b",
                }) as string,"col3","16%","left"),
                getTableCellsHeaderSimple(t("booking.bookingList.tableColumns.3", {
                    ns: "b2b",
                }) as string,"col4","16%","left"),
                {
                    ...getDSTableShaderElementsForFilterColumn(t("booking.bookingList.tableColumns.4", {
                        ns: "b2b",
                    }) as string,"col5","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersBookings["col5"], //<---
                },
                {
                    ...getDSTableShaderElementsForFilterColumn(t("booking.bookingList.tableColumns.5", {
                        ns: "b2b",
                    }) as string,"col6","16%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersBookings["col6"], //<---
                }
            ],
            hasSearchBox: true,
        },
        tableRows: getTableRowsBookings()
    };

    const myTableConfigVehicles_toApprove: ITableConfig = {
        ...getDSTableSharedElements(280),
        tableHeader: {
            tableCellsHeader: [
                {
                    ...getDSTableShaderElementsForFilterColumn(t("dashboard.vehicleColumns.0", { ns: "dashboard" }) as string,"col1","34%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersCredited["col1"], //<---
                },
                {
                    ...getDSTableShaderElementsForFilterColumn(t("dashboard.vehicleColumns.1", { ns: "dashboard" }) as string,"col2","33%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersCredited["col2"], //<---
                },
                getTableCellsHeaderSimple(t("dashboard.vehicleColumns.2", { ns: "dashboard" }) as string,"col3","33%","left")
            ],
            hasSearchBox: true,
        },
        tableRows: getTableRowsVehicles()
    };

    const myTableConfigVehicles_toCredit: ITableConfig = {
        ...getDSTableSharedElements(280),
        tableHeader: {
            tableCellsHeader: [
                {
                    ...getDSTableShaderElementsForFilterColumn( t("dashboard.vehicleColumns.0", { ns: "dashboard" }) as string,"col1","34%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersAwaiting["col1"], //<---
                },
                {
                    ...getDSTableShaderElementsForFilterColumn( t("dashboard.vehicleColumns.1", { ns: "dashboard" }) as string,"col2","33%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersAwaiting["col2"], //<---
                },
                getTableCellsHeaderSimple(t("dashboard.vehicleColumns.2", { ns: "dashboard" }) as string,"col3","33%","left")
            ],
            hasSearchBox: true,
        },
        tableRows: getTableRowsVehiclesToCredit()
    };



    const getBookingListSearchColumns = (index: number) => {
        return (
            index === 0 ||
            index === 1 ||
            index === 4 ||
            index === 5
        );
    };

    // Gestione dei cambiamenti dei filtri
    const handleFilterChangeBookings = (columnKey: string, value: string) => {
        setFiltersBookings((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };


    // Gestione del click sulla colonna 1 (ordinamento)
    const handleSortColumn1 = () => {
        setBookingsFiltered((prevList) => {
            let newOrder;
            if (isAscending === null) {
                // Se non abbiamo ancora uno stato iniziale, ordina in ordine decrescente
                newOrder = [...prevList].sort((a, b) => {
                    const dateA = moment(
                        parseDateForDS(
                            moment.unix(a.date).format(DATE_FORMAT),
                            IParseDateFormatType.DATE_FORMAT1
                        ),
                        "DD.MM.YYYY"
                    ).toDate();
                    const dateB = moment(
                        parseDateForDS(
                            moment.unix(b.date).format(DATE_FORMAT),
                            IParseDateFormatType.DATE_FORMAT1
                        ),
                        "DD.MM.YYYY"
                    ).toDate();
                    return dateB.getTime() - dateA.getTime(); // Ordine decrescente
                });
                setIsAscending(false); // Imposta l'ordine come decrescente
            } else {
                // Alterna tra crescente e decrescente
                newOrder = [...prevList].sort((a, b) => {
                    const dateA = moment(
                        parseDateForDS(
                            moment.unix(a.date).format(DATE_FORMAT),
                            IParseDateFormatType.DATE_FORMAT1
                        ),
                        "DD.MM.YYYY"
                    ).toDate();
                    const dateB = moment(
                        parseDateForDS(
                            moment.unix(b.date).format(DATE_FORMAT),
                            IParseDateFormatType.DATE_FORMAT1
                        ),
                        "DD.MM.YYYY"
                    ).toDate();
                    return isAscending
                        ? dateB.getTime() - dateA.getTime() // Ordine decrescente
                        : dateA.getTime() - dateB.getTime(); // Ordine crescente
                });
                setIsAscending(!isAscending); // Inverti l'ordine
            }

            return newOrder;
        });
    };

    useEffect(() => {
        let myFilteredList: IBookingElement[] = [];
        for (let i in bookings) {
            const serviceStr = parseService(bookings[i].service); // Ottieni la stringa del servizio
            const matchesBusinessId = businessId === '-1' || bookings[i].businessId === businessId;
            const matchesContractId = contractId === '-1' || bookings[i].contractId === contractId;
            if (
                bookings[i].reservationCode
                    .toLocaleLowerCase()
                    .includes(filtersBookings.col1.toLocaleLowerCase()) &&
                bookings[i].businessName
                    .toLocaleLowerCase()
                    .includes(filtersBookings.col4.toLocaleLowerCase()) &&
                bookings[i].shipperName
                    .toLocaleLowerCase()
                    .includes(filtersBookings.col5.toLocaleLowerCase()) &&
                serviceStr
                    .toLocaleLowerCase()
                    .includes(filtersBookings.col6.toLocaleLowerCase()) &&
                matchesBusinessId &&
                matchesContractId
            ) {
                myFilteredList.push(bookings[i]);
            }
        }
        setBookingsFiltered(myFilteredList);
    }, [filtersBookings, bookings,businessId,contractId]);

    const getTransportListSearchColumns = (index: number) => {
        return (
            index === 0
        );
    };
    const [filtersTransporterDelegations, setFiltersTransporterDelegations] = useState<{ [key: string]: string }>({
        col1: ""
    });
    const handleFilterChangeTransport = (columnKey: string, value: string) => {
        setFiltersTransporterDelegations((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };

    useEffect(() => {
        if (transportData !== undefined) {
            let myFilteredTransportData: ITransport = { ...transportData, delegations: [] };
            transportData.delegations.forEach((delegation) => {
                if (
                    delegation.businessName.toLocaleLowerCase().includes(
                        filtersTransporterDelegations.col1.toLocaleLowerCase()
                    )
                ) {
                    myFilteredTransportData.delegations.push(delegation);
                }
            });
            setTransportDataFiltered(myFilteredTransportData);
        }
    }, [filtersTransporterDelegations, bookings]);

    const myTableConfigDelegations: ITableConfig = {
        ...getDSTableSharedElements(280),
        tableHeader: {
            tableCellsHeader: [
                {
                    ...getDSTableShaderElementsForFilterColumn( t("dashboard.tableColsDelegations.0", { ns: "dashboard" }) as string,"col1","50%",t('general.buttons.cancel', { ns: 'app' }),"Conferma",t('general.buttons.search', { ns: 'app' })),
                    searchBoxValue:filtersTransporterDelegations["col1"], //<---
                },
                getTableCellsHeaderSimple(t("dashboard.tableColsDelegations.1", { ns: "dashboard" }) as string,"col2","50%","left")
            ],
            hasSearchBox: true,
        },
        tableRows: getTableDelegations()
    };


    return (
        <div>
            <Row>
                <Col>
                    <p className="pageTitle">Dashboard</p>
                </Col>
            </Row>
            {/*<p className="pageSubTitle">{t("dashboard.titles.10",{ns:'dashboard'})}</p>*/}
            <Container fluid>
                {/**Seleziona cliente e contratto */}
                <ClientContractFilter
                    selectContractId={selectContractId}
                    selectBusinessId={selectBusinessId}
                    selectSelectedBusiness={selectSelectedBusiness}
                    selectedBusiness={selectedBusiness}
                />

                {/**Calendario e contatore slot */}
                <Row>
                    {appUserProfile?.dashboardGrants.includes(
                        AppUserGrant.CALENDAR
                    ) && (
                        <Col
                            xs={12}
                            md={
                                appUserRole === AppUserRole.TL_MANAGER ||
                                appUserRole === AppUserRole.CARRIER ||
                                appUserRole === AppUserRole.BAY_OPERATOR ||
                                appUserRole === AppUserRole.EMPLOYEE ||
                                appUserRole === AppUserRole.RORO_EMPLOYEE ||
                                appUserRole === AppUserRole.SHIP_MANAGER
                                    ? 12
                                    : 7
                            }
                            style={{ marginBottom: "25px" }}
                        >
                            <div
                                style={{
                                    background:
                                        layoutMode === DsLayout.DARK_MODE
                                            ? "#0e2852"
                                            : "white",
                                    //borderRadius: "10px",
                                    marginLeft: "-15px",
                                    padding: "16px",
                                }}
                            >
                                <CalendarView
                                    showInteractions={false}
                                    _contractId={contractId}
                                    _businessId={businessId}
                                />
                            </div>
                        </Col>
                    )}

                    {appUserProfile?.dashboardGrants.includes(
                        AppUserGrant.CONTRACT_SLOT_CHART
                    ) && (
                        <Col
                            xs={12}
                            md={5}
                            style={{
                                background:
                                    layoutMode === DsLayout.DARK_MODE
                                        ? "#0e2852"
                                        : "white",
                                //borderRadius: "10px",
                                marginBottom: "25px",
                            }}
                        >
                            <div
                                style={{
                                    float: "left",
                                    width: "100%",
                                    fontWeight: "bold",
                                    fontFamily: "Lato, Lato-local, sans-serif",
                                    fontSize: "120%",
                                    marginTop: "15px",
                                    color:
                                        layoutMode === DsLayout.DARK_MODE
                                            ? "white"
                                            : "black",
                                }}
                            >
                                {t("dashboard.titles.1", { ns: "dashboard" })}
                            </div>
                            {contractData ? (
                                <div
                                    style={{
                                        alignContent: "center",
                                        verticalAlign: "center",
                                        height: "100%",
                                        width: "100%",
                                    }}
                                >
                                    <div style={{}}>
                                        <div
                                            style={{
                                                width: "fit-content",
                                                margin: "0 auto",
                                            }}
                                        >
                                            <ContractSlotChart
                                                contract={contractData}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <p
                                    style={{
                                        color:
                                            layoutMode === DsLayout.DARK_MODE
                                                ? "white"
                                                : "black",
                                    }}
                                >
                                    {t("dashboard.titles.8", {
                                        ns: "dashboard",
                                    })}
                                </p>
                            )}
                        </Col>
                    )}
                </Row>

                {/**Prenotazioni */}
                {appUserProfile?.dashboardGrants.includes(
                    AppUserGrant.BOOKING_LIST
                ) && (
                    <Row style={{ marginBottom: "25px",marginRight:'0px' }}>
                        <Col
                            xs={12}
                            md={12}
                            style={{
                                background:
                                    layoutMode === DsLayout.DARK_MODE
                                        ? "#0e2852"
                                        : "white",
                                //borderRadius: "10px",
                                height: "421px",
                            }}
                        >
                        {getComponentAndBookingsTable("bookings")}
                        </Col>
                    </Row>
                )}
                {/**Automezzi in attesa di accreditamento */}
                {appUserProfile?.dashboardGrants.includes(
                    AppUserGrant.VEHICLE_LIST
                ) && (
                    <Row style={{ marginBottom: "25px" }}>
                        <Col
                            xs={12}
                            md={appUserRole===AppUserRole.TL_MANAGER?5.8:12}
                            style={{
                                background:
                                    layoutMode === DsLayout.DARK_MODE
                                        ? "#0e2852"
                                        : "white",
                                //borderRadius: "10px",
                                height: "421px",
                                marginBottom:'25px',
                            }}
                        >
                            {/*getComponentsToApproveComponent()*/}
                            {getComponentAndBookingsTable("components_to_credit")}
                        </Col>
                        {appUserRole===AppUserRole.TL_MANAGER && <Col
                            xs={12}
                            md={5.8}
                            style={{
                                background:
                                    layoutMode === DsLayout.DARK_MODE
                                        ? "#0e2852"
                                        : "white",
                                //borderRadius: "10px",
                                height: "421px",
                                marginBottom:'25px',
                                marginLeft:'25px'
                            }}
                        >
                            {/*getComponentsToApproveComponent()*/}
                            {getComponentAndBookingsTable("components_to_approve")}
                        </Col>}
                    </Row>
                )}
                {/**Atti di delega */}
                {appUserProfile?.dashboardGrants.includes(
                    AppUserGrant.TRANSPORTER_DELEGATION_LIST
                ) && (
                    <Row style={{ marginBottom: "25px" }}>
                        <Col
                            xs={12}
                            md={12}
                            style={{
                                background:
                                    layoutMode === DsLayout.DARK_MODE
                                        ? "#0e2852"
                                        : "white",
                                //borderRadius: "10px",
                                height: "421px",
                            }}
                        >
                            <div style={{ marginTop: "20px", height: "10%" }}>
                                <div
                                    style={{
                                        float: "left",
                                        width: "fit-content",
                                        fontWeight: "bold",
                                        fontFamily:
                                            "Lato, Lato-local, sans-serif",
                                        fontSize: "120%",
                                        color:
                                            layoutMode === DsLayout.DARK_MODE
                                                ? "white"
                                                : "black",
                                    }}
                                >
                                    {t("dashboard.titles.6", {
                                        ns: "dashboard",
                                    })}
                                </div>
                                <div
                                    style={{
                                        float: "right",
                                        width: "fit-content",
                                    }}
                                >
                                    <Textlink
                                        textlinkSelected={false}
                                        isTopBarVariant={true}
                                        textlinkUrl="javascript:void(0)"
                                        textlinkText={t("dashboard.titles.7", {
                                            ns: "dashboard",
                                        })}
                                        textlinkTextSize="SMALL"
                                        isRouterLink={true}
                                        textlinkAriaLabel="aria-Textlink"
                                        onClickLink={() => {
                                            navigate(
                                                RoutePath.CONTRACTS_TRANSPORTATORS_INFO
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ height: "70%", overflowY: "hidden" }}>
                                {transportData &&
                                transportData.delegations.length !== 0 ? (
                                    <>
                                       {/*<SimpleTable
                                            columns={tableColsDelegations}
                                            rows={getTableRowsDelegations(
                                                transportDataFiltered
                                            )}
                                            getSearchColumns={
                                                getTransportListSearchColumns
                                            }
                                            columnInputHandlers={[
                                                (value) =>
                                                    handleFilterChangeTransport(
                                                        "col1",
                                                        value
                                                    )
                                            ]}
                                            isDashboard={true}
                                        />*/}
                                        {
                                            <Table 
                                                tableConfig={myTableConfigDelegations} 
                                                style={{}}
                                                onInputSearchBarChange={(event:Event)=>{
                                                    console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                                }}
                                                //FILTERS
                                                onClickRightAction={(event:Event)=>{
                                                    //console.log(event)
                                                    //navigate(contractListFiltered[(event as CustomEvent).detail.row].contractId);
                                                }}
                                                onTableInputChange={(event:Event)=>{
                                                    //console.log(event)
                                                    const focusCol = (event as CustomEvent).detail.col;
                                                    const focusValue = (event as CustomEvent).detail.value;
                                                    //console.log(focusCol + " - " + focusValue)
                                                    //handleFilterChangeTransport(focusCol, focusValue)
                                                }}
                                                onColumnSorting={(event:Event)=>{
                                                    //console.log((event as CustomEvent).detail.columnID) 
                                                }}
                                                onSubmitSearchedText={(event:Event)=>{
                                                const focusColtemp = (event as CustomEvent).detail.cells;
                                                let focusCol = '';
                                                switch (focusColtemp) {
                                                    case 0:
                                                        focusCol = "col1";
                                                        break;
                                                    case 1:
                                                        focusCol = "col2";
                                                        break;
                                                    case 2:
                                                        focusCol = "col3";
                                                        break;
                                                    case 3:
                                                        focusCol = "col4";
                                                        break;
                                                    case 4:
                                                        focusCol = "col5";
                                                        break;
                                                    case 5:
                                                        focusCol = "col6";
                                                        break;
                                                    default:
                                                        break;
                                                }
                                                const focusValue = (event as CustomEvent).detail.searchedText;
                                                handleFilterChangeTransport(focusCol, focusValue)
                                            }}
                                                onResetSearch={(event:Event)=>{
                                                //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                                                switch ((event as CustomEvent).detail.cells) {
                                                    case 0:
                                                        handleFilterChangeTransport("col1", "");
                                                        break;
                                                    case 1:
                                                        handleFilterChangeTransport("col2", "");
                                                        break;
                                                    case 2:
                                                        handleFilterChangeTransport("col3", "");
                                                        break;
                                                    case 3:
                                                        handleFilterChangeTransport("col4", "");
                                                        break;
                                                    case 4:
                                                        handleFilterChangeTransport("col5", "");
                                                        break;
                                                    case 5:
                                                        handleFilterChangeTransport("col6", "");
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }}
                                            />
                                            
                                        }
                                    </>
                                ) : (
                                    <p
                                        style={{
                                            color:
                                                layoutMode ===
                                                DsLayout.DARK_MODE
                                                    ? "white"
                                                    : "black",
                                        }}
                                    >
                                        {t(
                                            "transporter.transportData.noDelegationFound"
                                        )}
                                        {/*Non sono presenti deleghe a sistema*/}
                                    </p>
                                )}
                            </div>
                            {getDelegationLegend()}
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    );
};
export default DashboardView;
